import { render, staticRenderFns } from "./Evolucion.vue?vue&type=template&id=e67f9d2e&"
import script from "./Evolucion.vue?vue&type=script&lang=js&"
export * from "./Evolucion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports